export default __webpack_public_path__ + "static/media/black02.8a4dc995.jpg";